export const TEMPORARY_CONTEXT_CHAR_LIMIT = 25000;

export function serializeTemporaryContext(context, categoryMap = {}) {
  if (!context || typeof context !== 'object') return null;
  const content = typeof context.content === 'string' ? context.content : '';
  if (!content.trim()) return null;
  const id = String(context.id || `temp-${Date.now()}`);
  const truncated = content.length > TEMPORARY_CONTEXT_CHAR_LIMIT;
  return {
    id,
    name: String(context.name || context.title || id),
    category: categoryMap[id] || context.category || 'Temporary',
    content: truncated ? content.slice(0, TEMPORARY_CONTEXT_CHAR_LIMIT) : content,
    truncated,
  };
}

export function summarizeContextDiagnostics(diagnostics) {
  if (!diagnostics || typeof diagnostics !== 'object') return '';
  const mapped = Array.isArray(diagnostics.mappedContextsIncluded)
    ? diagnostics.mappedContextsIncluded.length
    : 0;
  const chunks = Array.isArray(diagnostics.chunksFetched)
    ? diagnostics.chunksFetched.length
    : 0;
  const skipped = Array.isArray(diagnostics.contextsSkipped)
    ? diagnostics.contextsSkipped.length
    : 0;
  const full = Array.isArray(diagnostics.fullContextsIncluded)
    ? diagnostics.fullContextsIncluded.length
    : 0;

  const parts = [];
  if (full > 0) parts.push(`${full} context${full === 1 ? '' : 's'} included fully`);
  if (mapped > 0) parts.push(`${mapped} large context${mapped === 1 ? '' : 's'} summarized`);
  if (chunks > 0) parts.push(`${chunks} chunk${chunks === 1 ? '' : 's'} fetched`);
  if (skipped > 0) parts.push(`${skipped} context item${skipped === 1 ? '' : 's'} skipped`);
  if (diagnostics.truncated) parts.push('context budget applied');
  return parts.length ? parts.join('; ') : '';
}
